/*@flow*/
import gql from 'graphql-tag';

import type { DocumentNode } from 'graphql';
export default (gql(`
  mutation createMarkerColors(
    $companyId: ID!
    $markerColors: [MarkerColorInput!]!
  ) {
    markerColorsCreate(
      input: { companyId: $companyId, markerColors: $markerColors }
    ) {
      success
      errors
    }
  }
`): DocumentNode);
